import { CollectionModel } from '@shared/models/restapi/Collection.Model';
import { ErrorWarningSummaryModel } from './ErrorWarningSummary.Model';

export class ErrorWarningSummaryCollectionModel extends CollectionModel<ErrorWarningSummaryModel> {
    public constructor() {
        super(ErrorWarningSummaryModel);
    }
}
